import React from 'react'
import MappingTabView from './MappingTabView'
import { MappingContextProvider } from '../Contexts/MappingContext'

const MappingPage = () => {
    return (
        <MappingContextProvider>
            <MappingTabView />
        </MappingContextProvider>
    )
}

export default MappingPage